import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { AclService } from './acl.service';

/**
 * The service that allows you to control the permissions of a some-element, table, list, etc.
 *
 * @export
 * @class AclHasPermissionDirective
 * @implements {OnDestroy}
 *
 * @howToUse
 * ```ts
 * <some-element [aclHasPermission]="['PERM_WRITE_APPROVALS']"></some-element>
 * <some-element *aclHasPermission="'PERM_WRITE_APPROVALS'"></some-element>
 * ```
 */
@Directive({
  selector: '[aclHasPermission]',
  exportAs: 'acl',
})
export class AclHasPermissionDirective {
  private permissions: string[];

  constructor(private aclService: AclService, private templateRef: TemplateRef<any>, private viewContainerRef: ViewContainerRef) {}

  @Input('aclHasPermission')
  set acl(value: string | string[]) {
    this.permissions = typeof value === 'string' ? [value] : value;
    this.updateView();
    // Get notified each time getAccountAbilityState state changes.
    this.aclService.getAccountAbilityState().subscribe(ability => this.updateView());
  }

  private updateView(): void {
    const hasAnyPermission = this.aclService.hasAnyPermission(this.permissions);
    this.viewContainerRef.clear();
    if (hasAnyPermission) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
